export const ACTIONS = {
  SET: "SET",
  SET_VALIDATIONS: "SET_VALIDATIONS",
  SET_CONFIG: "SET_CONFIG",
  SET_ERRORS: "SET_ERRORS",
  SET_ERROR: "SET_ERROR",
  SET_ASYNC_ERROR: "SET_ASYNC_ERROR",
  CLEAR_ASYNC_ERROR: "CLEAR_ASYNC_ERROR",
  MERGE: "MERGE",
  UPDATE_ANSWER: "UPDATE_ANSWER",
  NEXT_SECTION: "NEXT_SECTION",
  PREVIOUS_SECTION: "PREVIOUS_SECTION",
  VALIDATE_FORM: "VALIDATE_FORM",
  REMOVE_ERROR: "REMOVE_ERROR",
  SHOW_QUESTION: "SHOW_QUESTION",
  SET_ADDRESS_MODE: "SET_ADDRESS_MODE",
  SET_EDIT_MODE: "SET_EDIT_MODE",
  EDIT_QUESTION: "EDIT_QUESTION",
  APPEND_QUESTIONS: "APPEND_QUESTIONS",
  CONFIRM_ASSUMPTION_GROUP: "CONFIRM_ASSUMPTION_GROUP",
  SET_CURRENT_SECTION: "SET_CURRENT_SECTION",
  SET_VISIBLE: "SET_VISIBLE",
  SET_HIDDEN: "SET_HIDDEN",
  HYDRATE: "HYDRATE",
} as const;
